const courseInsights = {
  en: {
    common: {
      backToCourse: 'Back to course',
      backToAnalytics: 'Back to analytics',
      parent: 'Course analytics',
      clear: 'Clear',
      clearFilters: 'Clear filters',
    },
    categories: {
      loading: 'Loading categories...',
      loadFailed: 'Failed to load course',
      saved: 'Categories saved',
      saveFailed: 'Failed to save',
      categoryTitle: 'Category',
      categoryLabel: 'Course category',
      categoryDesc: 'Pick the main category for this course',
      categoryPlaceholder: 'Select category...',
      noCategory: 'No category',
      tagsTitle: 'Tags',
      tagsLabel: 'Tags',
      tagsDesc: 'Tags help students find this course',
      tagInputPlaceholderEmpty: 'Type a tag and press Enter...',
      tagInputPlaceholderMore: 'Add more...',
      tagsHint: 'Press Enter to add a tag, Backspace to remove the last one',
      removeTag: 'Remove tag: {tag}',
      previewTitle: 'Preview',
      previewEmpty: 'No category or tags set',
      saving: 'Saving...',
      saveChanges: 'Save changes',
      unsaved: 'Unsaved changes',
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Enrollments, completion and revenue for this course.',
      updated: 'Updated {time}',
      fromDateAria: 'From date',
      toDateAria: 'To date',
      clear: 'Clear',
      refreshTitle: 'Refresh',
      loading: 'Loading analytics...',
      errorLoad: 'Failed to load analytics',
      accessDenied: "You don't have access to view this analytics data.",
      errorExport: 'Failed to export',
      kpiEnrollments: 'Enrollments',
      kpiActiveStudents: 'Active students',
      kpiCompleted: 'Completed',
      kpiRevenue: 'Revenue',
      kpiAvgCompletion: 'Avg completion',
      navProgressTitle: 'Student progress',
      navProgressDesc: 'Per-student completion & activity',
      navDropoffTitle: 'Drop-off analysis',
      navDropoffDesc: 'Where students disengage',
      lessonPerformanceTitle: 'Lesson performance',
      lessonChartTitle: 'Completion by lesson',
      lessonChartDesc: 'Share of the students who started the course that finished each lesson',
      errorLessons: 'Failed to load the lesson figures',
      noLessonsTitle: 'No lesson figures yet',
      noLessonsDesc: 'Once the course has lessons and students, how each one is going shows here.',
      colLesson: 'Lesson',
      colStarted: 'Started',
      colCompleted: 'Completed',
      colCompletion: 'Completion',
      colAvgTime: 'Avg time',
      exportButton: 'Export',
      exportTitle: 'Export analytics',
      exportDesc: "Download a CSV snapshot of this course's data.",
      includeStudents: 'Include student list',
      includeLessons: 'Include lesson metrics',
      exporting: 'Exporting...',
      downloadCsv: 'Download CSV',
    },
    progress: {
      title: 'Student progress',
      loading: 'Loading students...',
      searchPlaceholder: 'Search by name or email...',
      statusAll: 'All statuses',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusInactive: 'Inactive',
      statusAtRisk: 'At risk',
      // Per-row status badge labels — grammatically distinct from the
      // statusX filter-dropdown labels above in languages (Russian) that
      // inflect a collective filter option ("Active students") differently
      // from a single row's own state ("(this student) is active").
      badgeActive: 'Active',
      badgeCompleted: 'Completed',
      badgeInactive: 'Inactive',
      badgeAtRisk: 'At risk',
      statusFilterAria: 'Filter by status',
      sortProgress: 'Sort by progress',
      sortLastAccessed: 'Sort by last accessed',
      sortAria: 'Sort by',
      errorLoad: 'Failed to load students',
      accessDenied: "You don't have access to view student progress for this course.",
      errorLoadDetails: 'Failed to load student details',
      emptyTitle: 'No students yet',
      emptyDesc: 'Once students enroll in this course, their progress will appear here.',
      filteredEmptyTitle: 'No students found',
      filteredEmptyDesc: 'Try another search or status.',
      countStudents: '{count} students',
      detailTitle: 'Student details',
      colName: 'Name',
      colStatus: 'Status',
      colProgress: 'Progress',
      colLastAccessed: 'Last accessed',
      statusUnknown: 'Unknown',
      detailEnrolled: 'Enrolled',
      overallProgress: 'Overall progress',
      openProfile: 'Open student profile',
      lessonsStarted: 'Lessons started',
      lessonsCompleted: 'Lessons completed',
      quizzesTaken: 'Quizzes taken',
      avgScore: 'Avg score',
    },
    dropoff: {
      title: 'Lesson drop-off analysis',
      subtitle: 'Lessons that lose 20% or more of the students who finished the lesson before them.',
      loading: 'Loading drop-off analysis...',
      errorLoad: 'Failed to load drop-off data',
      accessDenied: "You don't have access to view this drop-off data.",
      emptyTitle: 'No drop-off points',
      emptyDescription: 'No lesson loses 20% or more of the students who finished the lesson before it.',
      colLesson: 'Lesson title',
      colRate: 'Drop-off rate',
      colStudentsDropped: 'Students dropped',
      countLessons: '{count} lessons',
    },
  },
  ru: {
    common: {
      backToCourse: 'Назад к курсу',
      backToAnalytics: 'Назад к аналитике',
      parent: 'Аналитика курса',
      clear: 'Очистить',
      clearFilters: 'Сбросить фильтры',
    },
    categories: {
      loading: 'Загрузка категорий...',
      loadFailed: 'Не удалось загрузить курс',
      saved: 'Категории сохранены',
      saveFailed: 'Не удалось сохранить',
      categoryTitle: 'Категория',
      categoryLabel: 'Категория курса',
      categoryDesc: 'Выберите основную категорию для этого курса',
      categoryPlaceholder: 'Выберите категорию...',
      noCategory: 'Без категории',
      tagsTitle: 'Теги',
      tagsLabel: 'Теги',
      tagsDesc: 'Теги помогают студентам найти этот курс',
      tagInputPlaceholderEmpty: 'Введите тег и нажмите Enter...',
      tagInputPlaceholderMore: 'Добавить ещё...',
      tagsHint: 'Enter — добавить тег, Backspace — удалить последний',
      removeTag: 'Удалить тег: {tag}',
      previewTitle: 'Предпросмотр',
      previewEmpty: 'Категория и теги не заданы',
      saving: 'Сохранение...',
      saveChanges: 'Сохранить',
      unsaved: 'Есть несохранённые изменения',
    },
    analytics: {
      title: 'Аналитика',
      subtitle: 'Записи, завершение и доход по этому курсу.',
      updated: 'Обновлено {time}',
      fromDateAria: 'Дата с',
      toDateAria: 'Дата по',
      clear: 'Очистить',
      refreshTitle: 'Обновить',
      loading: 'Загрузка аналитики...',
      errorLoad: 'Не удалось загрузить аналитику',
      accessDenied: 'У вас нет доступа для просмотра этих данных аналитики.',
      errorExport: 'Не удалось выполнить экспорт',
      kpiEnrollments: 'Записи',
      kpiActiveStudents: 'Активные студенты',
      kpiCompleted: 'Завершили',
      kpiRevenue: 'Доход',
      kpiAvgCompletion: 'Ср. завершение',
      navProgressTitle: 'Прогресс студентов',
      navProgressDesc: 'Завершение и активность по каждому студенту',
      navDropoffTitle: 'Анализ оттока',
      navDropoffDesc: 'Где студенты теряют интерес',
      lessonPerformanceTitle: 'Эффективность уроков',
      lessonChartTitle: 'Завершение по урокам',
      lessonChartDesc: 'Какая доля студентов, начавших курс, завершила каждый урок',
      errorLessons: 'Не удалось загрузить данные по урокам',
      noLessonsTitle: 'Данных по урокам пока нет',
      noLessonsDesc: 'Когда в курсе появятся уроки и студенты, здесь будет видно, как идёт каждый урок.',
      colLesson: 'Урок',
      colStarted: 'Начали',
      colCompleted: 'Завершили',
      colCompletion: 'Завершение',
      colAvgTime: 'Ср. время',
      exportButton: 'Экспорт',
      exportTitle: 'Экспорт аналитики',
      exportDesc: 'Скачать CSV-снимок данных этого курса.',
      includeStudents: 'Включить список студентов',
      includeLessons: 'Включить метрики уроков',
      exporting: 'Экспорт...',
      downloadCsv: 'Скачать CSV',
    },
    progress: {
      title: 'Прогресс студентов',
      loading: 'Загрузка студентов...',
      searchPlaceholder: 'Поиск по имени или email...',
      statusAll: 'Все статусы',
      statusActive: 'Активные',
      statusCompleted: 'Завершившие',
      statusInactive: 'Неактивные',
      statusAtRisk: 'В зоне риска',
      badgeActive: 'Активен',
      badgeCompleted: 'Завершён',
      badgeInactive: 'Неактивен',
      badgeAtRisk: 'В зоне риска',
      statusFilterAria: 'Фильтр по статусу',
      sortProgress: 'Сортировать по прогрессу',
      sortLastAccessed: 'Сортировать по последнему посещению',
      sortAria: 'Сортировка',
      errorLoad: 'Не удалось загрузить студентов',
      accessDenied: 'У вас нет доступа для просмотра прогресса студентов этого курса.',
      errorLoadDetails: 'Не удалось загрузить данные студента',
      emptyTitle: 'Пока нет студентов',
      emptyDesc: 'Как только студенты запишутся на курс, их прогресс появится здесь.',
      filteredEmptyTitle: 'Студенты не найдены',
      filteredEmptyDesc: 'Попробуйте другой запрос или статус.',
      countStudents: '{count} студентов',
      detailTitle: 'Данные студента',
      colName: 'Имя',
      colStatus: 'Статус',
      colProgress: 'Прогресс',
      colLastAccessed: 'Последнее посещение',
      statusUnknown: 'Неизвестно',
      detailEnrolled: 'Записан',
      overallProgress: 'Общий прогресс',
      openProfile: 'Открыть профиль студента',
      lessonsStarted: 'Уроков начато',
      lessonsCompleted: 'Уроков завершено',
      quizzesTaken: 'Тестов пройдено',
      avgScore: 'Средний балл',
    },
    dropoff: {
      title: 'Анализ оттока по урокам',
      subtitle: 'Уроки, на которых отсеивается 20% и более студентов, завершивших предыдущий урок.',
      loading: 'Загрузка анализа оттока...',
      errorLoad: 'Не удалось загрузить данные об оттоке',
      accessDenied: 'У вас нет доступа для просмотра этих данных об оттоке.',
      emptyTitle: 'Точек оттока нет',
      emptyDescription: 'Ни один урок не теряет 20% и более студентов, завершивших предыдущий урок.',
      colLesson: 'Название урока',
      colRate: 'Уровень оттока',
      colStudentsDropped: 'Студентов отсеялось',
      countLessons: '{count} уроков',
    },
  },
  uz: {
    common: {
      backToCourse: 'Kursga qaytish',
      backToAnalytics: 'Tahlilga qaytish',
      parent: 'Kurs tahlili',
      clear: 'Tozalash',
      clearFilters: 'Filtrlarni tozalash',
    },
    categories: {
      loading: 'Kategoriyalar yuklanmoqda...',
      loadFailed: "Kursni yuklab bo'lmadi",
      saved: 'Kategoriya va teglar saqlandi',
      saveFailed: "Saqlab bo'lmadi",
      categoryTitle: 'Kategoriya',
      categoryLabel: 'Kurs kategoriyasi',
      categoryDesc: 'Bu kurs uchun asosiy kategoriyani tanlang',
      categoryPlaceholder: 'Kategoriyani tanlang...',
      noCategory: 'Kategoriyasiz',
      tagsTitle: 'Teglar',
      tagsLabel: 'Teglar',
      tagsDesc: "O'quvchilar bu kursni topishi uchun teglar qo'shing",
      tagInputPlaceholderEmpty: 'Teg kiriting va Enter bosing...',
      tagInputPlaceholderMore: "Yana qo'shish...",
      tagsHint: "Teg qo'shish uchun Enter, oxirgisini o'chirish uchun Backspace bosing",
      removeTag: "Tegni o'chirish: {tag}",
      previewTitle: "Ko'rinishi",
      previewEmpty: 'Kategoriya yoki teglar belgilanmagan',
      saving: 'Saqlanmoqda...',
      saveChanges: 'Saqlash',
      unsaved: "Saqlanmagan o'zgarishlar",
    },
    analytics: {
      title: 'Tahlil',
      subtitle: "Kurs bo'yicha yozilish, tugallash va daromad ko'rsatkichlari.",
      updated: 'Yangilandi {time}',
      fromDateAria: 'Sanadan',
      toDateAria: 'Sanagacha',
      clear: 'Tozalash',
      refreshTitle: 'Yangilash',
      loading: 'Tahlil yuklanmoqda...',
      errorLoad: "Tahlilni yuklab bo'lmadi",
      accessDenied: "Sizda bu tahlil ma'lumotlarini ko'rish uchun ruxsat yo'q.",
      errorExport: "Eksport qilib bo'lmadi",
      kpiEnrollments: 'Yozilganlar',
      kpiActiveStudents: "Faol o'quvchilar",
      kpiCompleted: 'Tugatganlar',
      kpiRevenue: 'Daromad',
      kpiAvgCompletion: "O'rtacha tugallanish",
      navProgressTitle: "O'quvchi progressi",
      navProgressDesc: "Har bir o'quvchining progressi va faolligi",
      navDropoffTitle: "To'xtash tahlili",
      navDropoffDesc: "O'quvchilar qayerda qiziqishni yo'qotmoqda",
      lessonPerformanceTitle: 'Dars samaradorligi',
      lessonChartTitle: "Darslar bo'yicha tugallash",
      lessonChartDesc: "Kursni boshlagan o'quvchilarning har bir darsni tugatgan ulushi",
      errorLessons: "Dars ko'rsatkichlarini yuklab bo'lmadi",
      noLessonsTitle: "Hozircha dars ko'rsatkichlari yo'q",
      noLessonsDesc: "Kursda darslar va o'quvchilar paydo bo'lgach, har bir dars qanday ketayotgani shu yerda ko'rinadi.",
      colLesson: 'Dars',
      colStarted: 'Boshlaganlar',
      colCompleted: 'Tugatganlar',
      colCompletion: 'Tugallanish',
      colAvgTime: "O'rtacha vaqt",
      exportButton: 'Eksport',
      exportTitle: 'Tahlilni eksport qilish',
      exportDesc: "Ushbu kurs ma'lumotlarining CSV nusxasini yuklab oling.",
      includeStudents: "O'quvchilar ro'yxatini qo'shish",
      includeLessons: "Dars metrikalarini qo'shish",
      exporting: 'Eksport qilinmoqda...',
      downloadCsv: 'CSV yuklab olish',
    },
    progress: {
      title: "O'quvchi progressi",
      loading: "O'quvchilar yuklanmoqda...",
      searchPlaceholder: "Ism yoki email bo'yicha qidirish...",
      statusAll: 'Barcha holatlar',
      statusActive: 'Faol',
      statusCompleted: 'Tugallangan',
      statusInactive: 'Nofaol',
      statusAtRisk: "Xavf ostida",
      badgeActive: 'Faol',
      badgeCompleted: 'Tugallangan',
      badgeInactive: 'Nofaol',
      badgeAtRisk: "Xavf ostida",
      statusFilterAria: "Holat bo'yicha filtrlash",
      sortProgress: "Progress bo'yicha saralash",
      sortLastAccessed: "Oxirgi faollik bo'yicha saralash",
      sortAria: 'Saralash',
      errorLoad: "O'quvchilarni yuklab bo'lmadi",
      accessDenied: "Sizda ushbu kurs o'quvchilari progressini ko'rish uchun ruxsat yo'q.",
      errorLoadDetails: "O'quvchi ma'lumotlarini yuklab bo'lmadi",
      emptyTitle: "Hozircha o'quvchilar yo'q",
      emptyDesc: "O'quvchilar kursga yozilgach, ularning progressi shu yerda ko'rinadi.",
      filteredEmptyTitle: "O'quvchilar topilmadi",
      filteredEmptyDesc: "Boshqa so'rov yoki holatni sinab ko'ring.",
      countStudents: "{count} ta o'quvchi",
      detailTitle: "O'quvchi ma'lumotlari",
      colName: 'Ism',
      colStatus: 'Holat',
      colProgress: 'Progress',
      colLastAccessed: 'Oxirgi faollik',
      statusUnknown: "Noma'lum",
      detailEnrolled: 'Yozilgan sana',
      overallProgress: 'Umumiy progress',
      openProfile: "O'quvchi profilini ochish",
      lessonsStarted: 'Boshlangan darslar',
      lessonsCompleted: 'Tugallangan darslar',
      quizzesTaken: 'Topshirilgan testlar',
      avgScore: "O'rtacha ball",
    },
    dropoff: {
      title: "Darslar bo'yicha to'xtash tahlili",
      subtitle: "Oldingi darsni tugatgan o'quvchilarning 20% va undan ko'pini yo'qotayotgan darslar.",
      loading: "To'xtash tahlili yuklanmoqda...",
      errorLoad: "To'xtash ma'lumotlarini yuklab bo'lmadi",
      accessDenied: "Sizda bu to'xtash ma'lumotlarini ko'rish uchun ruxsat yo'q.",
      emptyTitle: "To'xtash nuqtalari yo'q",
      emptyDescription: "Hech bir dars oldingi darsni tugatgan o'quvchilarning 20% va undan ko'pini yo'qotmayapti.",
      colLesson: 'Dars nomi',
      colRate: "To'xtash darajasi",
      colStudentsDropped: "To'xtagan o'quvchilar",
      countLessons: '{count} ta dars',
    },
  },
};

export default courseInsights;
